import { FC, MouseEventHandler, useState } from "react";
import Modal from "../Modal";
import { Answer } from "../../store/answer";
import { ApplicationState, AppThunkDispatch } from "../../store";
import { connect, ConnectedProps } from "react-redux";
import Suspense from "../suspense/Suspense";
import { FavoriteEntry } from "../../store/favorite";
import { favoriteActionCreators } from "../../actions/favoriteActions";

interface AddFavoriteEntryModalProps extends ConnectedProps<typeof connector> {
    isVisible: boolean;
    answer: Answer;
    onClose: () => void;
}

const AddFavoriteEntryModal: FC<AddFavoriteEntryModalProps> = (props) => {
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [validationError, setValidationError] = useState<string | null>(null);
    
    const { createFavoriteEntry } = props;
    const { favoriteState } = props;
    const { answer } = props;
    
    const handleCancelButtonClick: MouseEventHandler<HTMLButtonElement> = () => {
        props.onClose();
    }
    
    const handleAddButtonClick: MouseEventHandler<HTMLButtonElement> = async () => {
        setIsSubmitted(true);
        
        if (favoriteState.data) {
            createFavoriteEntry({ answerId: answer.id ?? -1, userId: "", answer: answer });
        }
        else {
            setValidationError("An error occurred. Please try again.");
        }
    }
    
    const handleCloseButtonClick: MouseEventHandler<HTMLButtonElement> = () => {
        props.onClose();
        setIsSubmitted(false);
        setValidationError(null);
    }
    
    const getMessage = () => {
        let message = "";
        message = "Are you sure you want to add this question to your favorites?";
        return message;
    }
    
    const getSubmittedMessage = () => {
        return "The question has been successfully added to your favorites.";
    }
    
    const getErrorMessage = () => {
        let message = "An unknown error occurred.";
        message = "An error occurred while adding this question to your favorites.";
        return message;
    }
    
    return (
        <Modal
            isVisible={props.isVisible}
            modalStyle="popup-small"
        >
            <Suspense isLoading={favoriteState.isLoading}>
                {!isSubmitted ? (
                    <>
                        <h2>{getMessage()}</h2>

                        <div className="drawer-split">
                            <button className="cancel" onClick={handleCancelButtonClick}>
                                <i className="fa fa-times" />  Cancel
                            </button>
                            <button className="save" onClick={handleAddButtonClick}>
                                <i className="fa fa-plus"/>  Add
                            </button>
                        </div>
                    </>
                ) : (
                    <>
                        <h2>{validationError !== null ? validationError : (favoriteState.error ? getErrorMessage() : getSubmittedMessage())}</h2>
                        
                        <div className="drawer-split">
                            <button className="cancel" onClick={handleCloseButtonClick}>
                                <i className="fa fa-times" />  Close
                            </button>
                        </div>
                    </>
                )}
            </Suspense>
        </Modal>
    );
}

const mapStateToProps = (applicationState: ApplicationState) => {
    const favoriteState = applicationState.favorite;
    
    return { favoriteState };
}

const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
    createFavoriteEntry: (favoriteEntry: Omit<FavoriteEntry, 'favoriteId'>) => {
        dispatch(favoriteActionCreators.createFavoriteEntry(favoriteEntry));
    }
});

const connector = connect(mapStateToProps, mapDispatchToProps);
export default connector(AddFavoriteEntryModal);